import { render, staticRenderFns } from "./flove_image.vue?vue&type=template&id=93ce0cf2&scoped=true"
import script from "./flove_image.vue?vue&type=script&lang=js"
export * from "./flove_image.vue?vue&type=script&lang=js"
import style0 from "./flove_image.vue?vue&type=style&index=0&id=93ce0cf2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ce0cf2",
  null
  
)

export default component.exports